var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	31926: () => (loadStrictSingletonVersion("default", "@angular/core", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
	47808: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
	54640: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
	10932: () => (loadStrictSingletonVersion("default", "@angular/common", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
	70530: () => (loadStrictSingletonVersion("default", "@angular/common/http", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
	42052: () => (loadStrictSingletonVersion("default", "@angular/forms", true, [1,21,2,0], () => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
	34969: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
	52929: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
	481: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
	29025: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
	76009: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
	59683: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
	3913: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
	22785: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
	30913: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
	43607: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
	50797: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 65129))))),
	80753: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))),
	92655: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
	80893: () => (loadStrictSingletonVersion("default", "@angular/cdk/accordion", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))),
	58543: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))),
	76561: () => (loadStrictSingletonVersion("default", "@angular/cdk/text-field", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))),
	37905: () => (loadStrictSingletonVersion("default", "@angular/cdk/table", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))),
	27987: () => (loadStrictSingletonVersion("default", "@angular/cdk/stepper", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))),
	33925: () => (loadStrictSingletonVersion("default", "@angular/cdk/tree", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/tree */ 72714))))),
	86727: () => (loadStrictSingletonVersion("default", "@angular/material/core", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))),
	49697: () => (loadStrictSingletonVersion("default", "@angular/cdk/drag-drop", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 50854))))),
	46885: () => (loadStrictSingletonVersion("default", "@angular/material/autocomplete", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 79771))))),
	72023: () => (loadStrictSingletonVersion("default", "@angular/material/badge", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/badge */ 16256))))),
	79071: () => (loadStrictSingletonVersion("default", "@angular/material/button-toggle", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/button-toggle */ 59864))))),
	47253: () => (loadStrictSingletonVersion("default", "@angular/material/datepicker", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))),
	64891: () => (loadStrictSingletonVersion("default", "@angular/material/divider", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/divider */ 14102))))),
	35067: () => (loadStrictSingletonVersion("default", "@angular/material/input", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))),
	10103: () => (loadStrictSingletonVersion("default", "@angular/material/menu", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/menu */ 31034))))),
	20919: () => (loadStrictSingletonVersion("default", "@angular/material/paginator", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/paginator */ 24624))))),
	90423: () => (loadStrictSingletonVersion("default", "@angular/material/progress-spinner", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))),
	50743: () => (loadStrictSingletonVersion("default", "@angular/material/radio", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/radio */ 53804))))),
	88065: () => (loadStrictSingletonVersion("default", "@angular/material/select", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))),
	90111: () => (loadStrictSingletonVersion("default", "@angular/material/sidenav", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/sidenav */ 17049))))),
	1: () => (loadStrictSingletonVersion("default", "@angular/material/sort", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/sort */ 22047))))),
	3143: () => (loadStrictSingletonVersion("default", "@angular/material/table", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/table */ 77697))))),
	11045: () => (loadStrictSingletonVersion("default", "@angular/material/tabs", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/tabs */ 38223))))),
	5559: () => (loadStrictSingletonVersion("default", "@angular/material/tooltip", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/tooltip */ 80640))))),
	16695: () => (loadStrictSingletonVersion("default", "@angular/material/form-field", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))),
	34198: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", true, [1,21,0,8], () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
	9553: () => (loadStrictSingletonVersion("default", "@angular/material/button", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))),
	3779: () => (loadStrictSingletonVersion("default", "@angular/material/checkbox", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/checkbox */ 97024))))),
	13795: () => (loadStrictSingletonVersion("default", "@angular/material/icon", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))),
	88441: () => (loadStrictSingletonVersion("default", "@angular/material/slide-toggle", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/slide-toggle */ 8827))))),
	9678: () => (loadStrictSingletonVersion("default", "@angular/router", true, [1,21,2,0], () => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
	47810: () => (loadSingletonVersion("default", "@ngx-translate/core", true, [1,15,0,0], () => (() => (__webpack_require__(/*! @ngx-translate/core */ 90852))))),
	44727: () => (loadStrictSingletonVersion("default", "@angular/material/bottom-sheet", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/bottom-sheet */ 15244))))),
	51173: () => (loadStrictSingletonVersion("default", "@angular/material/card", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/card */ 53777))))),
	5735: () => (loadStrictSingletonVersion("default", "@angular/material/chips", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/chips */ 12772))))),
	64555: () => (loadStrictSingletonVersion("default", "@angular/material/stepper", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/stepper */ 56622))))),
	26493: () => (loadStrictSingletonVersion("default", "@angular/material/dialog", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/dialog */ 12587))))),
	89043: () => (loadStrictSingletonVersion("default", "@angular/material/expansion", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/expansion */ 19322))))),
	74631: () => (loadStrictSingletonVersion("default", "@angular/material/grid-list", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/grid-list */ 16488))))),
	53725: () => (loadStrictSingletonVersion("default", "@angular/material/list", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/list */ 20943))))),
	18039: () => (loadStrictSingletonVersion("default", "@angular/material/progress-bar", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/progress-bar */ 26354))))),
	70159: () => (loadStrictSingletonVersion("default", "@angular/material/slider", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/slider */ 64992))))),
	45675: () => (loadStrictSingletonVersion("default", "@angular/material/snack-bar", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 3347))))),
	26327: () => (loadStrictSingletonVersion("default", "@angular/material/toolbar", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/material/toolbar */ 39552))))),
	40805: () => (loadStrictSingletonVersion("default", "@angular/cdk/clipboard", true, [1,21,2,14], () => (() => (__webpack_require__(/*! @angular/cdk/clipboard */ 52352))))),
	47466: () => (loadStrictSingletonVersion("default", "ngx-toastr", true, [1,20,0,5], () => (() => (__webpack_require__(/*! ngx-toastr */ 54285))))),
	26103: () => (load("default", "tuula-common", false, () => (Promise.all([__webpack_require__.e("default-node_modules_moment-timezone_index_js-webpack_sharing_consume_default_angular_cdk_dra-eca5ec"), __webpack_require__.e("default-projects_tuula-common_src_public-api_ts")]).then(() => (() => (__webpack_require__(/*! tuula-common */ 43307)))))))
};
var initialConsumes = [31926,47808,54640,10932,70530,42052,34969,52929,481,29025,76009,59683,3913,22785,30913,43607,50797,80753,92655,80893,58543,76561,37905,27987,33925];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"polyfills": [
		31926,
		47808,
		54640,
		10932,
		70530,
		42052,
		34969,
		52929,
		481,
		29025,
		76009,
		59683,
		3913,
		22785,
		30913,
		43607,
		50797,
		80753,
		92655,
		80893,
		58543,
		76561,
		37905,
		27987,
		33925
	],
	"default-node_modules_moment-timezone_index_js-webpack_sharing_consume_default_angular_cdk_dra-eca5ec": [
		86727,
		49697,
		46885,
		72023,
		79071,
		47253,
		64891,
		35067,
		10103,
		20919,
		90423,
		50743,
		88065,
		90111,
		1,
		3143,
		11045,
		5559,
		16695
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop-w-77f509": [
		34198,
		9553,
		3779,
		13795,
		88441,
		9678,
		47810
	],
	"default-projects_c4p-portal-util_src_lib_shared-forms_social-area_goal-set-services_goalset-g-764807": [
		44727,
		51173,
		5735,
		64555,
		26493,
		89043,
		74631,
		53725,
		18039,
		70159,
		45675,
		26327,
		40805
	],
	"default-webpack_sharing_consume_default_ngx-toastr_ngx-toastr-webpack_sharing_consume_default-dac50c": [
		47466,
		26103
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}